import { AssetId } from "@carnegie-learning/common-types";
import { Asset } from "@carnegie-learning/cure-types";
import { AssignmentPagination, AssignmentPaginationParameters } from "@carnegie-learning/data-access-angular-passport";
import { createAction, props } from "@ngrx/store";
import {
    PPAssignment as Assignment,
    CourseMetrics,
    UpdateCourseAssignmentPayload,
} from "cli-types";

// ------ Load all assignments for teacher that need Eval across all teacher's active teacher-class ------
export const LOAD_NEED_EVAL_ASSIGNMENTS =
    "[Assignments] Load Need Eval Assignments";
export const LOAD_NEED_EVAL_ASSIGNMENTS_FAIL =
    "[Assignments] Load Need Eval Assignments Fail";
export const LOAD_NEED_EVAL_ASSIGNMENTS_SUCCESS =
    "[Assignments] Load Need Eval Assignments Success";

export const LoadNeedEvalAssignments = createAction(
    LOAD_NEED_EVAL_ASSIGNMENTS,
    props<{
        paginationParams: AssignmentPaginationParameters;
    }>()
);

export const LoadNeedEvalAssignmentsFail = createAction(
    LOAD_NEED_EVAL_ASSIGNMENTS_FAIL,
    props<{
        payload: any;
    }>()
);

export const LoadNeedEvalAssignmentsSuccess = createAction(
    LOAD_NEED_EVAL_ASSIGNMENTS_SUCCESS,
    props<{
        payload: AssignmentPagination;
    }>()
);

// ------ Load assignments for a student in Course - plural ('s' postfix) ------
export const LOAD_EVAL_ASSIGNMENTS = "[Assignments] Load Eval Assignments";
export const LOAD_EVAL_ASSIGNMENTS_FAIL =
    "[Assignments] Load Eval Assignments Fail";
export const LOAD_EVAL_ASSIGNMENTS_SUCCESS =
    "[Assignments] Load Eval Assignments Success";

export const LoadEvalAssignments = createAction(
    LOAD_EVAL_ASSIGNMENTS,
    props<{
        payload: AssignmentPaginationParameters;
    }>()
);

export const LoadEvalAssignmentsFail = createAction(
    LOAD_EVAL_ASSIGNMENTS_FAIL,
    props<{
        payload: any;
    }>()
);

export const LoadEvalAssignmentsSuccess = createAction(
    LOAD_EVAL_ASSIGNMENTS_SUCCESS,
    props<{
        payload: AssignmentPagination;
    }>()
);

// ------ Load assignments for a Course (not User) ------
export const LOAD_COURSE_ASSIGNMENTS = "[Course Assignments] Load Assignments";
export const LOAD_COURSE_ASSIGNMENTS_FAIL =
    "[Course Assignments] Load Assignments Fail";
export const LOAD_COURSE_ASSIGNMENTS_SUCCESS =
    "[Course Assignments] Load Assignments Success";

export const LoadCourseAssignments = createAction(
    LOAD_COURSE_ASSIGNMENTS,
    props<{
        payload: AssignmentPaginationParameters;
        courseId?: number;
    }>()
);

export const LoadCourseAssignmentsFail = createAction(
    LOAD_COURSE_ASSIGNMENTS_FAIL,
    props<{
        payload: any;
    }>()
);

export const LoadCourseAssignmentsSuccess = createAction(
    LOAD_COURSE_ASSIGNMENTS_SUCCESS,
    props<{
        payload: AssignmentPagination;
    }>()
);

export const loadAssignmentsAssignedInEditionCourses = createAction(
    "[Course Assignments] Load Assignments Assigned In Edition Courses",
    props<{
        payload: AssignmentPaginationParameters;
        courseId?: number;
    }>()
);

// ------ Update Assignment: Student Profile View ------
export const UPDATE_STUDENT_PROFILE_ASSIGNMENT =
    "[Assignment] Update Student Profile Assignment";
export const UPDATE_STUDENT_PROFILE_ASSIGNMENT_FAIL =
    "[Assignment] Update Student Profile Assignment Fail";
export const UPDATE_STUDENT_PROFILE_ASSIGNMENT_SUCCESS =
    "[Assignment] Update Student Profile Assignment Success";

export const UpdateStudentProfileAssignment = createAction(
    UPDATE_STUDENT_PROFILE_ASSIGNMENT,
    props<{
        params: any;
        assignmentID: number;
    }>()
);
export const UpdateStudentProfileAssignmentFail = createAction(
    UPDATE_STUDENT_PROFILE_ASSIGNMENT_FAIL,
    props<{
        payload: any;
    }>()
);
export const UpdateStudentProfileAssignmentSuccess = createAction(
    UPDATE_STUDENT_PROFILE_ASSIGNMENT_SUCCESS,
    props<{
        payload: Assignment;
    }>()
);

// ------ Delete assignment ------
export const DELETE_ASSIGNMENT = "[Assignment] Delete";
export const DELETE_ASSIGNMENT_FAIL = "[Assignment] Delete Fail";
export const DELETE_ASSIGNMENT_SUCCESS = "[Assignment] Delete Success";

export const DeleteAssignment = createAction(
    DELETE_ASSIGNMENT,
    props<{
        payload: Assignment;
    }>()
);
export const DeleteAssignmentFail = createAction(
    DELETE_ASSIGNMENT_FAIL,
    props<{
        payload: any;
    }>()
);
export const DeleteAssignmentSuccess = createAction(
    DELETE_ASSIGNMENT_SUCCESS,
    props<{
        assignmentID: number;
    }>()
);

// ------ Set Params ------
export const SET_COURSE_ASSIGNMENTS_PAGINATION_PARAMS =
    "[Assignment] Set Course Pagination Params";
export const SET_STUDENT_ASSIGNMENTS_PAGINATION_PARAMS =
    "[Assignment] Set Student Pagination Params";

export const SetCourseAssignmentsPaginationParams = createAction(
    SET_COURSE_ASSIGNMENTS_PAGINATION_PARAMS,
    props<{
        payload: any;
    }>()
);
export const SetStudentAssignmentsPaginationParams = createAction(
    SET_STUDENT_ASSIGNMENTS_PAGINATION_PARAMS,
    props<{
        payload: any;
    }>()
);

// // ------ Load studentMetrics ------
export const LOAD_ASSIGNMENTS_COURSE_METRICS = "[Assignment] Load Metrics";
export const LOAD_ASSIGNMENTS_COURSE_METRICS_FAIL =
    "[Assignment] Load Metrics Fail";
export const LOAD_ASSIGNMENTS_COURSE_METRICS_SUCCESS =
    "[Assignment] Load Metrics Success";

export const LoadAssignmentsCourseMetrics = createAction(
    LOAD_ASSIGNMENTS_COURSE_METRICS,
    props<{
        courseID: number;
        assetId: AssetId;
        shortAssignableType: string;
    }>()
);
export const LoadAssignmentsCourseMetricsFail = createAction(
    LOAD_ASSIGNMENTS_COURSE_METRICS_FAIL,
    props<{
        payload: any;
    }>()
);
export const LoadAssignmentsCourseMetricsSuccess = createAction(
    LOAD_ASSIGNMENTS_COURSE_METRICS_SUCCESS,
    props<{
        courseID: number;
        assetId: AssetId;
        shortAssignableType: string;
        courseMetrics: CourseMetrics;
    }>()
);

// ------ Load Assignment Asset ------
export const LOAD_ASSIGNMENT_ASSET = "[Assignment] Load Assignment Asset";
export const LOAD_ASSIGNMENT_ASSET_FAIL =
    "[Assignment] Load Assignment Asset Fail";
export const LOAD_ASSIGNMENT_ASSET_SUCCESS =
    "[Assignment] Load Assignment Asset Success";
export const LoadAssignmentAsset = createAction(
    LOAD_ASSIGNMENT_ASSET,
    props<{
        assignmentId: number;
        assetId: AssetId;
    }>()
);
export const LoadAssignmentAssetFail = createAction(
    LOAD_ASSIGNMENT_ASSET_FAIL,
    props<{
        payload: any;
    }>()
);
export const LoadAssignmentAssetSuccess = createAction(
    LOAD_ASSIGNMENT_ASSET_SUCCESS,
    props<{
        assignmentId: number;
        asset: Asset;
    }>()
);

// ------ Load All Assignments Asset ------
export const LOAD_ALL_ASSIGNMENT_ASSETS =
    "[Assignment] Load All Assignment Assets";
export const LOAD_ALL_ASSIGNMENT_ASSETS_FAIL =
    "[Assignment] Load All Assignment Assets Fail";
export const LOAD_ALL_ASSIGNMENT_ASSETS_SUCCESS =
    "[Assignment] Load All Assignment Assets Success";
export const LoadAllAssignmentAssets = createAction(
    LOAD_ALL_ASSIGNMENT_ASSETS,
    props<{
        assignments: Assignment[];
    }>()
);
export const LoadAllAssignmentAssetsFail = createAction(
    LOAD_ALL_ASSIGNMENT_ASSETS_FAIL,
    props<{
        payload: any;
    }>()
);
export const LoadAllAssignmentAssetsSuccess = createAction(
    LOAD_ALL_ASSIGNMENT_ASSETS_SUCCESS,
    props<{
        assignments: Assignment[];
        assets: Asset[];
    }>()
);

// ------ Set/Clear Selected Assignment: Course/Student/Assignment ------
export const SET_CURRENT_ASSIGNMENT = "[Assignment] Set Current Assignment";
export const CLEAR_CURRENT_ASSIGNMENT = "[Assignment] Clear Current Assignment";

export const SetCurrentAssignment = createAction(
    SET_CURRENT_ASSIGNMENT,
    props<{
        payload: Assignment;
    }>()
);

export const ClearCurrentAssignment = createAction(CLEAR_CURRENT_ASSIGNMENT);

// ------ Update teacher-class ------
export const UPDATE_COURSE_ASSIGNMENT = "[Assignment] Update Assignment Course";
export const UPDATE_COURSE_ASSIGNMENT_FAIL =
    "[Assignment] Update Assignment Course Fail";
export const UPDATE_COURSE_ASSIGNMENT_SUCCESS =
    "[Assignment] Update Assignment Course Success";

export const UpdateCourseAssignment = createAction(
    UPDATE_COURSE_ASSIGNMENT,
    props<{
        assetId: AssetId;
        shortAssignableType: string;
        courseID: number;
        payload: UpdateCourseAssignmentPayload;
    }>()
);
export const UpdateCourseAssignmentFail = createAction(
    UPDATE_COURSE_ASSIGNMENT_FAIL,
    props<{
        payload: any;
    }>()
);
export const UpdateCourseAssignmentSuccess = createAction(
    UPDATE_COURSE_ASSIGNMENT_SUCCESS,
    props<{
        payload: any;
    }>()
);

// ------- Updated Course Assignments
export const UPDATE_COURSE_ASSIGNMENTS =
    "[Assignment] Update Course Assignments";

export const UpdateCourseAssignments = createAction(
    UPDATE_COURSE_ASSIGNMENTS,
    props<{
        payload: any;
        assignmentID: number;
        quickEval: boolean;
    }>()
);

// ------ Set Filter Box State -------
export const SET_COURSE_ASSIGNMENT_FILTER_BOX_OPENED =
    "[Assignment] Course Filter Box Opened";

export const SetCourseAssignmentsFilterBoxOpened = createAction(
    SET_COURSE_ASSIGNMENT_FILTER_BOX_OPENED,
    props<{
        payload: any;
    }>()
);

// ------ Set Filter Box State -------
export const SET_STUDENT_ASSIGNMENT_FILTER_BOX_OPENED =
    "[Assignment] Student Filter Box Opened";

export const SetStudentAssignmentsFilterBoxOpened = createAction(
    SET_STUDENT_ASSIGNMENT_FILTER_BOX_OPENED,
    props<{
        payload: any;
    }>()
);

// ------ Reset State ------
export const RESET_ASSIGNMENT_STORE = "[Assignment] Reset Assignment Store";
export const ResetAssignmentsStore = createAction(RESET_ASSIGNMENT_STORE);

// ------ Reset Assignments State ------
export const RESET_ASSIGNMENT_STORE_ASSIGNMENTS =
    "[Assignment] Reset Assignment Store Assignments";
export const ResetAssignmentsStoreAssignments = createAction(
    RESET_ASSIGNMENT_STORE_ASSIGNMENTS
);

// ------ Preview Student Assignment Activity ------
export const previewStudentAssignmentActivity = createAction(
    "[Assignments] Preview Student Assignment Activity",
    props<{
        assignment: Assignment;
        componentRef: Function;
    }>()
);
export const previewStudentAssignmentActivityFail = createAction(
    "[Assignments] Preview Student Assignment Activity Fail",
    props<{
        error: Error;
    }>()
);
export const closedPreviewAssetDialog = createAction(
    "[Assignments] Closed Preview Asset Dialog"
);
